import { gql } from '@apollo/client';

export const BILLING_SFTP_TYPES = gql`
  query BillingSftpTypes {
    billingSftpTypes { id name direction path host enabled }
  }
`;
export const BILLING_SFTP_CONFIG = gql`
  query BillingSftpConfig {
    billingSftpConfig { version bucket host port username hostKeySha256 passwordConfigured }
  }
`;
export const SAVE_BILLING_SFTP_CONFIG = gql`
  mutation SaveBillingSftpConfig($input: BillingSftpConfigInput!) {
    saveBillingSftpConfig(input: $input) { version bucket host port username hostKeySha256 passwordConfigured }
  }
`;
export const SAVE_BILLING_SFTP_TYPE = gql`
  mutation SaveBillingSftpType($input: BillingSftpTypeInput!) {
    saveBillingSftpType(input: $input) { id name direction path host enabled }
  }
`;
export const SAVE_BILLING_SFTP_TYPES = gql`
  mutation SaveBillingSftpTypes($types: [BillingSftpTypeInput!]!) {
    saveBillingSftpTypes(types: $types) { id name direction path host enabled }
  }
`;
export const BILLING_SFTP_FILES = gql`
  query BillingSftpFiles($archived: Boolean, $processed: Boolean, $direction: String, $typeId: Int, $offset: Int, $limit: Int) {
    billingSftpFiles(archived: $archived, processed: $processed, direction: $direction, typeId: $typeId, offset: $offset, limit: $limit) {
      total
      files { id typeId typeName direction folder filename sizeBytes transferState attempts lastError processed archived createdAt transferredAt }
    }
  }
`;
export const UPDATE_BILLING_SFTP_FILE = gql`
  mutation UpdateBillingSftpFile($input: BillingSftpFileInput!) {
    updateBillingSftpFile(input: $input) { id processed archived transferState attempts lastError }
  }
`;
export const UPLOAD_BILLING_SFTP_FILE = gql`
  mutation UploadBillingSftpFile($input: BillingSftpUploadInput!) {
    uploadBillingSftpFile(input: $input) { id typeId typeName direction folder filename transferState processed archived }
  }
`;
export const DOWNLOAD_BILLING_SFTP_FILE = gql`
  mutation DownloadBillingSftpFile($id: String!) {
    downloadBillingSftpFile(id: $id) { contents contentType filename }
  }
`;
